import allComponentsDefinitionsMap from '../../dist/originalSchemas/componentsDefinitionsMap.json'
import allFullyRestrictedSchemas from '../../dist/allFullyRestrictedSchemas.json'
import restrictionMapSchemas from '../../dist/allRestrictionMapSchemas.json'
import * as schemaArrangement from '../schemaArrangement'

const schemas = schemaArrangement.arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames(allFullyRestrictedSchemas)
const restrictionMap =
    schemaArrangement.arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames(restrictionMapSchemas)

export default {
    ...schemas,
    allComponentsDefinitionsMap,
    componentsDefinitionsMap: allComponentsDefinitionsMap,
    restrictionMap
}
